<div class="container pt-3" [innerHTML]="infoPanel">
</div>
